import Stack from "react-bootstrap/Stack";
import { capitalizeString } from "../../../../utilities/helpers";

export default function SelectedUser({ user }) {
  const getNameInitials = (user) => {
    if (user) {
      return `${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}`;
    }
  };

  return (
    <Stack direction="horizontal" gap={3}>
      <div className={`user-profile user-profile--primary`}>
        <span>{getNameInitials(user)}</span>
      </div>
      <Stack gap={1}>
        <span className="heading m-0">
          {capitalizeString(user?.firstName)} {capitalizeString(user?.lastName)}
        </span>
        <span className="d-block small">{user?.email}</span>
      </Stack>
    </Stack>
  );
}
